module.exports = __webpack_public_path__ + "img/blue-pencil-icon.e239ae0a.svg";